(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Truelytics",
                {
                    url: "/Truelytics?autoLogin",
                    component: "truelytics",
                    PageTitle: "Truelytics",
                    requiredPermissions: "Truelytics:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("truelytics",
        {
            templateUrl: "App/Resources/Truelytics/truelytics.template.html",
            controller: truelyticsCtrl,
            bindings: {
                states: "<"
            }
        });

    truelyticsCtrl.$inject = ["amplitudeService", "eligibilityFormApi", "eligibilityFormDialog", "surveys"];

    function truelyticsCtrl(amplitudeService, eligibilityFormApi, eligibilityFormDialog, surveys) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.truelyticsId).then(function (response) {
                $ctrl.submitted = response;
            });
        });

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.truelyticsId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        };
        
    }
})(window.app, window.angular); // jshint ignore:line